import BackButton from 'components/BackButton';
import { Loading } from 'components/loading/Loading';
import React, { useEffect, useState } from 'react';
import { fetchUserRequestedItemDetail } from 'services/api/userRequestedItem';
import { showError } from 'utils';
import BasicDetails from './basicDetails';
import styles from './index.module.scss';

const UserRequestedItemDetails = (props) => {
  const { userRequestedItemId } = props.match.params;
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState({}) as any;

  const fetchUserRequestedItemDetailFn = async () => {
    setLoading(true);
    try {
      const response = await fetchUserRequestedItemDetail(userRequestedItemId);
      setData(response);
    } catch (e) {
      showError(e);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchUserRequestedItemDetailFn();
  }, []);

  const getHeader = () => (
    <div className={styles['header']}>
      <div className={styles['heading']}>User Requested Item Details</div>
      <div className={styles['header-buttons']}>
        <BackButton />
      </div>
    </div>
  );

  return (
    <div id={'main-container'} className={`${styles['main-container']}`}>
      {loading && <Loading />}
      {getHeader()}
      <BasicDetails details={data} />
    </div>
  );
};

export default UserRequestedItemDetails;